import React from 'react';
import useImageModal from '../shared/useImageModal';

export default function FacebookPhotoGrid({ photos }) {
  const { openModal, modal } = useImageModal();
  const count = photos.length;

  if (count === 0) return null;

  const clickImage = (src) => openModal(src);

  return (
    <>
      {/* Render the modal */}
      {modal}

      {/* Grid layout */}
      {count === 1 && (
        <div className="fb-grid fb-grid-single">
          <img src={photos[0].image} alt="" onClick={() => clickImage(photos[0].image)} />
        </div>
      )}

      {count === 2 && (
        <div className="fb-grid fb-grid-two">
          {photos.map((p, i) => (
            <img key={i} src={p.image} alt="" onClick={() => clickImage(p.image)} />
          ))}
        </div>
      )}

      {count === 3 && (
        <div className="fb-grid fb-grid-three">
          <div className="big">
            <img src={photos[0].image} alt="" onClick={() => clickImage(photos[0].image)} />
          </div>
          <div className="small-col">
            <img src={photos[1].image} alt="" onClick={() => clickImage(photos[1].image)} />
            <img src={photos[2].image} alt="" onClick={() => clickImage(photos[2].image)} />
          </div>
        </div>
      )}

      {count === 4 && (
        <div className="fb-grid fb-grid-four">
          {photos.map((p, i) => (
            <img key={i} src={p.image} alt="" onClick={() => clickImage(p.image)} />
          ))}
        </div>
      )}

      {count >= 5 && (
        <div className="fb-grid fb-grid-more">
          <img src={photos[0].image} alt="" onClick={() => clickImage(photos[0].image)} />
          <img src={photos[1].image} alt="" onClick={() => clickImage(photos[1].image)} />
          <img src={photos[2].image} alt="" onClick={() => clickImage(photos[2].image)} />

          <div className="more-overlay" onClick={() => clickImage(photos[3].image)}>
            +{count - 3}
          </div>
        </div>
      )}
    </>
  );
}
